(function () {
    "use strict";

    angular
        .module("PWAPoCApp")
        .controller("SupportController", supportController);

    supportController.$inject = ["$scope", "$kWindow"];

    function supportController($scope, $kWindow) {
        $scope.sendReport = sendReport;
        $scope.openDiagPanel = openDiagPanel;

        function sendReport() {
            $kWindow.open({
                options: {
                    modal: true,
                    title: "Send rapport",
                    draggable: false,
                    movable: false,
                    resizable: false,
                    visible: false,
                    height: 250,
                    width: 350,
                },
                templateUrl: "app/support/send-report-view.html",
                windowTemplateUrl: "app/shared/modal-base.html",
                controller: "SendReportController",
            });
        }

        function openDiagPanel() {
            $kWindow.open({
                options: {
                    modal: true,
                    title: "Diagnostics panel",
                    draggable: false,
                    movable: false,
                    resizable: false,
                    visible: false,
                    height: "100%",
                    width: "100%",
                },
                templateUrl: "app/diagnostics/diagnostics-modal-view.html",
                windowTemplateUrl: "app/shared/modal-base.html",
                controller: "diagnosticsModalController",
            });
        }
    }
})();
